/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mail_Compose_RecipientsInputs */

const en_mail_compose_recipients = /** @type {(inputs: Mail_Compose_RecipientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To (${i?.count}):`)
};

const de_mail_compose_recipients = /** @type {(inputs: Mail_Compose_RecipientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An (${i?.count}):`)
};

/**
* | output |
* | --- |
* | "To ({count}):" |
*
* @param {Mail_Compose_RecipientsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_recipients = /** @type {((inputs: Mail_Compose_RecipientsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_RecipientsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_recipients(inputs)
	return en_mail_compose_recipients(inputs)
});